module.exports = __webpack_public_path__ + "img/auth-posnania-action.7f63925d.png";